module.exports = __webpack_public_path__ + "static/media/8OLA21.fedca7c6.jpg";